import { AccountType, IUserContext } from '@notes/aria-common-schema-logger'
import { IAuthenticatedUserInfo } from '@notes/webintegrations-common'

export function getOTelLoggingUserContextFromUserInformation(userInfo: IAuthenticatedUserInfo | undefined): IUserContext | undefined {
  if (!userInfo) {
    return undefined
  }

  return {
    tenantId: userInfo.tenantId,
    userId: userInfo.authType === 'o365' ? userInfo.userObjectId!! : userInfo.userCid!!,
    userType: userInfo.authType === 'o365' ? AccountType.OrgIdPUID : AccountType.MSACID,
  }
}
